import { ONE_KIBIBYTE } from '@lucidlink/uicore';
export const validateChunkSize = (chunkSize) => {
    if (!Number.isInteger(chunkSize)) {
        throw new Error(`Provided chunk size: ${chunkSize} is not an integer. Provide a positive integer bigger than 0 and multiple of 1024`);
    }
    if (chunkSize <= 0) {
        throw new Error(`Provided chunk size: ${chunkSize} is less than or equal to 0. Provide a positive integer bigger than 0 and multiple of 1024`);
    }
    // This is a business requirement, chunk sizes must be divisble by 1024 otherwise we read the files very
    // inefficiently - getting some bytes from previous / next blocks
    if (chunkSize % ONE_KIBIBYTE !== 0) {
        throw new Error(`Provided chunk size: ${chunkSize} is not a multiple of 1024. Provide a positive integer bigger than 0 and multiple of 1024`);
    }
};
export const validateMaxStreamResponseTimeWait = (maxStreamResponseTimeWait) => {
    if (!Number.isInteger(maxStreamResponseTimeWait)) {
        throw new Error(`Passed stream response time ${maxStreamResponseTimeWait} is not an integer. Provide a positive integer bigger than 0`);
    }
    if (maxStreamResponseTimeWait <= 0) {
        throw new Error(`Passed stream response time ${maxStreamResponseTimeWait} is less than or 0. Provide a positive integer bigger than 0`);
    }
};
